
import { API } from 'aws-amplify'


const consumerProfileService = {
    update,
    getOne,
    create,
    checkEmail,
    createMeetingRequest,
    createLead
}

const myAPI = "adisorProfilesAPI"
const path = '/consumerProfile';


async function getOne(params) {
    return API.get(myAPI, `${path}/${params}`);
}

async function checkEmail(params) {
    return API.get(myAPI, `${path}/userExists/${params}`);
}

async function update(params, myInit) {
    return API.put(myAPI, `${path}/${params}`, addCurrentUserInfo(myInit));
}

async function create(myInit) {
    return API.post(myAPI, path, myInit);
}

async function createMeetingRequest(meetingRequest) {
    return API.post(myAPI, `${path}/meetingRequest`, meetingRequest);
}

async function createLead(lead) {
    return API.post(myAPI, `${path}/lead`, lead);
}

function addCurrentUserInfo(myInit) {
    myInit.body.currentUserId = JSON.parse(localStorage.getItem('user')).id;
    return myInit;
}


export default consumerProfileService;